import Vue from "vue";
import VueMeta from "vue-meta";

// Add core components
import "@c/Core";

// Firebase
import { firebase, app, analytics, perf } from "./firebase.config";

Vue.use(VueMeta, {
  keyName: "meta",
  attribute: "data-meta",
  refreshOnceOnNavigation: true
});

Vue.prototype.$firebase = {
  firebase,
  app,
  analytics,
  perf
};

Vue.config.productionTip = false;
